import React from "react";
import "./stat.styles.scss";
import { connect } from "react-redux";
export const AdminComponent = ({ firstName }) => {
  return (
    <>
      <div
        className="container"
      >
        <div
          className="container-fluid welcome-head bg-white mt-4 p-4"
          style={{ border: "1px solid #d8dbe0" }}
        >
          <h2>
            Hi, <strong>{firstName}</strong>
          </h2>
          <p>
            Welcome to <strong>{localStorage.getItem("companyName")}</strong>{" "}
            dashboard{" "}
          </p>
        </div>

        <div className="container-fluid mt-3">
          <div className="row">
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white homeCard mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="text-primary m-0">
                    {" "}
                    <strong> No of Users</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("users")} </strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="m-0 text-primary">
                    {" "}
                    <strong> No of Locations</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("locations")}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className="m-0 text-primary">
                    {" "}
                    <strong> No of Products</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("products")}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 p-2">
              <div className="bg-white mx-auto text-center homeCard">
                <div className="homeCard-child">
                  <p className=" m-0 text-primary">
                    {" "}
                    <strong> Product Categories</strong>{" "}
                  </p>
                  <p className="m-0 pt-2">
                    {" "}
                    <strong> {localStorage.getItem("productCategory")}</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    firstName: state.userReducer.firstName,
  };
}
const mapDispatchToProps = (dispatch) => ({
  UpdateUser(payload) {
    dispatch({ type: "UPDATE_USER", payload });
  },

  LoadUsers(payload) {
    dispatch({ type: "LOAD_USERS", payload });
  },
  AddUser(payload) {
    dispatch({ type: "ADD_USER", payload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminComponent);
